class Redirector {
  redirectToLoginForm(keycloakIDPAdapter, locale) {
    window.location = keycloakIDPAdapter.createLoginUrl(locale);
  }
  redirectToLoginFormBM(keycloakIDPAdapter, locale) {
    window.location = keycloakIDPAdapter.createLoginUrl(locale, null, true);
  }
}
const redirector = new Redirector();
export default redirector;